module.exports = __webpack_public_path__ + "static/media/location.291870ee.svg";